import React, { useMemo } from 'react';
import { Accordion, AccordionSection, Col, createArrayInRange, Row } from '@visalex/core';

import cx from 'clsx';
import { useTranslation, withTranslation } from 'next-i18next';

import accordionStyles from '../../GreenCards/TypesOfGreenCard/GreenCard/GreenCard.module.scss';
import commonStyles from '../SolutionsPage.module.scss';
import styles from './TurnkeySolutions.module.scss';

const TurnkeySolutions = () => {
  const { t, i18n } = useTranslation();
  const items = useMemo(
    () =>
      createArrayInRange(0, 5).map((index) => ({
        key: index,
        withoutVisalex: {
          title: t(`solutions.turnkey.items.${index}.without-visalex.title`),
          description: t(`solutions.turnkey.items.${index}.without-visalex.description`),
        },
        withVisalex: {
          title: t(`solutions.turnkey.items.${index}.with-visalex.title`),
          description: t(`solutions.turnkey.items.${index}.with-visalex.description`),
        },
        imageName: {
          lg: `/images/solutions/turnkey/${index}-lg.png`,
          md: `/images/solutions/turnkey/${index}-md.png`,
          xs: `/images/solutions/turnkey/${index}-xs.png`,
        },
      })),
    [i18n.language]
  );
  const withoutVisalex = useMemo(() => t('solutions.turnkey.without-visalex'), [i18n.language]);
  const withVisalex = useMemo(() => t('solutions.turnkey.with-visalex'), [i18n.language]);

  const withoutVisalexHeaderContent = (
    <>
      <img src="/images/solutions/without-visalex.svg" alt={withoutVisalex} />
      <span>{withoutVisalex}</span>
    </>
  );

  const withVisalexHeaderContent = (
    <>
      <img src="/images/solutions/with-visalex.svg" alt={withVisalex} />
      <span>{withVisalex}</span>
    </>
  );

  return (
    <div className={styles['turnkey-solutions']}>
      <Row>
        <Col className={styles['turnkey-solutions__header']}>
          <h2>{t('solutions.turnkey.title')}</h2>
          <h3>{t('solutions.turnkey.subtitle')}</h3>
          <p className={commonStyles['description-big']}>{t('solutions.turnkey.description')}</p>
        </Col>
      </Row>
      <div>
        {items.map((item) => (
          <Row key={item.key} className={styles['turnkey-item']}>
            <Col xs={12} lg={7} className={cx('order-1', item.key % 2 === 0 && 'order-lg-0')}>
              {[0, 1].map((index: number) => (
                <Accordion
                  key={index}
                  classNames={{
                    accordion:
                      index === 0 ? accordionStyles['accordion-list_transparent'] : accordionStyles['accordion-list'],
                    sectionHeader: accordionStyles['accordion-list__title'],
                    sectionContent: accordionStyles['accordion-list__body'],
                  }}
                >
                  {[0].map((id: number) => (
                    <AccordionSection
                      key={id}
                      index={id}
                      isOpen
                      header={
                        <div className={styles['turnkey-item__header']}>
                          <div>{index === 0 ? withoutVisalexHeaderContent : withVisalexHeaderContent}</div>
                        </div>
                      }
                    >
                      <p className={styles['turnkey-item__title']}>
                        {index === 0 ? item.withoutVisalex.title : item.withVisalex.title}
                      </p>
                      <p className={cx(styles['turnkey-item__description'], commonStyles['description-small'])}>
                        {index === 0 ? item.withoutVisalex.description : item.withVisalex.description}
                      </p>
                    </AccordionSection>
                  ))}
                </Accordion>
              ))}
            </Col>
            <Col xs={12} lg={5} className="d-flex align-items-center">
              <img
                src={item.imageName.lg}
                alt={item.withVisalex.title}
                className={cx(styles['turnkey-item__image'], 'd-none d-lg-block')}
              />
              <img
                src={item.imageName.md}
                alt={item.withVisalex.title}
                className={cx(styles['turnkey-item__image'], 'd-none d-md-block d-lg-none')}
              />
              <img
                src={item.imageName.xs}
                alt={item.withVisalex.title}
                className={cx(styles['turnkey-item__image'], 'd-block d-md-none')}
              />
            </Col>
          </Row>
        ))}
      </div>
    </div>
  );
};

export default withTranslation()(TurnkeySolutions);
